import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSidePanelopen } from "../../redux/actions/mapPanelControlActions";
import { IconButton } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import OpenPanel from "@material-ui/icons/ArrowRight";
import ClosePanel from "@material-ui/icons/ArrowLeft";

const useStyles = makeStyles((theme) => ({
  drawerIconBtn: {
    backgroundColor: theme.palette.primary.light,
    position: "fixed",
    marginLeft: "0px",
    marginTop: "0px",
    //zIndex : theme.zIndex.modal -50,
    zIndex: 999,
  },
}));

const DrawerIcons = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const panelProps = useSelector((state) => state.mapPanelSetting);
  const settings = useSelector((state) => state.settings);
  const handleDrawerOpen = (status) => {
    dispatch(setSidePanelopen(status));
  };

  return (
    <div className={classes.drawerIconBtn}>
      {!panelProps.isSidePanelOpen ? (
        <IconButton
          aria-label="Search"
          style={{ color: "white" }}
          onClick={() => handleDrawerOpen(true)}
        >
          {settings.language == "en" ? <OpenPanel /> : <ClosePanel />}
        </IconButton>
      ) : (
        // <IconButton
        //   aria-label="Search"
        //   color="white"
        //   style={{ color: "white" }}
        //   onClick={() => handleDrawerOpen(false)}
        // >
        //   {settings.language == "en" ? <ClosePanel /> : <OpenPanel />}
        // </IconButton>
        ""
      )}
    </div>
  );
};

export default DrawerIcons;
